var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.111 9H2L12 2L21.9998 8.99989L20.929 9L20.93 19C20.93 20.656 19.586 22 17.93 22H15V14H9V22H6.111C4.455 22 3.111 20.656 3.111 19V9ZM7.5 20.5H6.111C5.28343 20.5 4.611 19.8276 4.611 19V9.00328L12 3.83098L19.429 9.03129L19.43 19C19.4299 19.8275 18.7575 20.5 17.93 20.5H16.5V14C16.5 13.1716 15.8284 12.5 15 12.5H9C8.17157 12.5 7.5 13.1716 7.5 14V20.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.b391cdb3043b2c15115d4a65491e1838.svg";
export { ForwardRef as ReactComponent };